import {Databases} from "appwrite";
import {client, database_id} from "../lib/appwrite";

const GALLERY_COLLECTION_ID = "68374e1a00176a9bfba4"
const GALLERY_IMAGES_RECORD = "gallery_images"
const databases = new Databases(client);

export const galleryService = {
  async getGalleryImages(): Promise<string[]> {
    try {
      const response = await databases.getDocument(
        database_id,
        GALLERY_COLLECTION_ID,
        GALLERY_IMAGES_RECORD
      );
      return response.images as string[];
    } catch (error) {
      throw error;
    }
  },
  async updateGalleryImages(imagesId: string[]): Promise<string[]> {
    try {
      const response = await databases.updateDocument(
        database_id,
        GALLERY_COLLECTION_ID,
        GALLERY_IMAGES_RECORD,
        {images: imagesId}
      )
      const images = response.images as string[]
      return images;
    } catch (error) {
      throw error;
    }
  },
}